export { VpDialogActions } from './VpDialogActions';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogActions/index.js